const getMaximumRequestAmount = () => 99900 // TODO: [FUTURE] Get from API
const getMinimumRequestAmount = () => 500 // TODO: [FUTURE] Get from API
const getAppVersion = () => import.meta.env.VITE_VERSION
const getApiBaseURL = () => import.meta.env.VITE_API_BASE_URL
const getAppBaseURL = () => import.meta.env.VITE_BASE_URL || globalThis.location.origin
const getDefaultTheme = () => import.meta.env.VITE_DEFAULT_THEME || 'dark'
const getPatronAppBaseURL = () => import.meta.env.VITE_PATRON_APP_BASE_URL
const getEnv = () => import.meta.env.MODE
const getApiTimeout = () => Number.parseInt(import.meta.env.VITE_API_TIMEOUT || "10000")

const AppService = {
  getAppVersion,
  getMinimumRequestAmount,
  getMaximumRequestAmount,
  getApiBaseURL,
  getAppBaseURL,
  getDefaultTheme,
  getPatronAppBaseURL,
  getEnv,
  getApiTimeout,
}

export default AppService
